import React from 'react';
import { motion } from 'framer-motion';
import { GiftIcon } from 'lucide-react';
const bonuses = [{
  n: '01',
  title: 'Diagnóstico Anti-Recursada',
  desc: 'Descubrí en 10 minutos exactamente por qué estás desaprobando y qué tenés que corregir primero. Incluye test de 25 preguntas con plan de acción personalizado según tu área crítica.',
  price: '$14.990'
}, {
  n: '02',
  title: 'Planificador Cuatrimestral Elite',
  desc: 'Organizá todo tu cuatrimestre en una sola herramienta y dejá de llegar tarde a parciales, finales y entregas. Calendario completo + Matriz de Prioridad Académica + Tracker semanal.',
  price: '$9.990'
}, {
  n: '03',
  title: 'Checklist Final sin Pánico',
  desc: 'Llegá al día del examen con claridad y seguridad total. Checklist de 48 hs, 24 hs y mañana del examen para escritos y orales. Incluye hoja de último repaso printable.',
  price: '$7.990'
}, {
  n: '04',
  title: 'Plantillas de Apuntes Inteligentes',
  desc: 'Convertí cualquier clase o texto pesado en apuntes claros y estudiables. Plantillas Cornell, Mapa Conceptual, Fichas de Memoria y Resumen en 1 página listas para completar.',
  price: '$7.990'
}, {
  n: '05',
  title: 'Prompts de IA para Estudiar Más Rápido',
  desc: '20 prompts listos para copiar y pegar. Entendé textos difíciles, creá preguntas de examen y preparate para orales usando inteligencia artificial como tu tutor personal.',
  price: '$5.990'
}];
export function Bonuses() {
  return <section aria-label="Bonos" className="bg-ink-2 border-y border-white/5" data-id="element-14" data-mp="2zhoh8agnurna">
      <div className="mx-auto max-w-5xl px-5 py-20 pt-[0px] pb-[22px]" data-id="element-15" data-mp="2ui237yt0d7df">
        <h2 className="text-center font-display text-2xl font-black text-white sm:text-4xl pt-[28px]" data-id="element-16" data-mp="38gijohgoac8r">
          🎁 5 Bonos estratégicos — siempre incluidos
        </h2>

        <div className="mt-12 grid gap-5 sm:grid-cols-2" data-id="element-17" data-mp="nq1dx6xbhgw4">
          {bonuses.map((b, i) => <motion.div key={b.n} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.4,
          delay: i % 2 * 0.08
        }} className="relative flex flex-col rounded-2xl border border-gold/25 bg-ink p-6" data-id="element-18" data-mp="nruj0hsa7t20" data-mpi={i}>
              <div className="mb-3 flex flex-wrap items-center justify-between gap-2" data-id="element-19" data-mp="3lhi5u9rd8een">
                <span className="inline-flex items-center gap-1.5 rounded-full bg-gold/15 px-3 py-1 text-xs font-bold text-gold" data-id="element-20" data-mp="3qhwffw8m7wes">
                  <GiftIcon className="h-3.5 w-3.5" data-id="element-21" data-mp="2xu0bc6gpv27z" /> Bono {b.n}
                </span>
                <span className="text-sm font-bold" data-id="element-22" data-mp="2xrntruevetvg">
                  <span className="text-white/40 line-through" data-id="element-23" data-mp="32s22leoaq7uj">{b.price}</span>{' '}
                  <span className="text-verde-soft" data-id="element-24" data-mp="37k3bqrq63igc">GRATIS</span>
                </span>
              </div>
              <h3 className="text-base font-bold text-white" data-id="element-25" data-mp="2a57iwjzazci4">{b.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-white/60" data-id="element-26" data-mp="2f396ni7obzzx">{b.desc}</p>
            </motion.div>)}
        </div>

        <div className="mt-10 rounded-2xl border border-verde/40 bg-verde/10 p-6 text-center" data-id="element-27" data-mp="27k9jd1h3doba">
          <p className="text-base font-bold text-white sm:text-lg" data-id="element-28" data-mp="22knaf48aqu8a">
            Valor total de los bonos:{' '}
            <span className="text-white/50 line-through" data-id="element-29" data-mp="1xksf8ohhnihf">$46.950</span>{' '}
            <span className="text-gold text-[15px]" data-id="element-30" data-mp="1tkrukm3sqb1x">HOY GRATIS CON TU MEGAPACK</span>
          </p>
        </div>
      </div>
    </section>;
}